import { render, staticRenderFns } from "./ConsuntivoRisorse.vue?vue&type=template&id=7d3fea68&"
import script from "./ConsuntivoRisorse.vue?vue&type=script&lang=js&"
export * from "./ConsuntivoRisorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports